import { ColumnHelper } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";

import { MatchesTableEntry } from "../../../../hooks/use_resource_matches";
import { MatchCell } from "./match_cell";

type CreateMatchColumnArgs = {
  headerLabel: string;
};

export const createMatchColumn = (
  columnHelper: ColumnHelper<MatchesTableEntry>,
  { headerLabel }: CreateMatchColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "match",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <MatchCell value={info.getValue().matchScore} />,
    enableSorting: false,
    size: 40
  });
